import React from 'react';
import Currency from '../Currency';
import IHasItemDataProps from './IHasItemDataProps';
import IHasLinkProps from './IHasLinkProps';
import { ModalTriggerButton } from '../Modals/ModalTriggerButton';
import { eSingleFields } from '../context/state/eSingleFields';
import { ISalePriceOfPropertyViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';

interface ISalePriceOfPropertyProps extends IHasItemDataProps<ISalePriceOfPropertyViewItem>, IHasLinkProps {}

export default class SalePriceOfProperty extends React.Component<ISalePriceOfPropertyProps> {
  public render() {
    const { data, hasEditPermissions } = this.props;
    return (
      <div className="cost-data__row cost-data__aligned-row">
        <div className="cost-data__content-cell cost-data__content-row-number" />
        <div className="cost-data__content-cell cost-data__content-name">Sale Price of Property</div>
        <div className="cost-data__content-cell cost-data__content-amount cost-data__content-amount--text-content">
          <ModalTriggerButton fieldName={eSingleFields.purchase_price} disabled={!hasEditPermissions}>
            <Currency value={data.buyer_at_closing} />
          </ModalTriggerButton>
        </div>
        <div className="cost-data__content-cell cost-data__content-control" />
      </div>
    );
  }
}
